import { validatePhoneNumber } from '../../../helper/common'

export const validatePhone = (v, showPhoneInput = true) => {
  if (!showPhoneInput) return ''

  const { isValid, errorMessage } = validatePhoneNumber(String(v || ''))
  return isValid ? '' : errorMessage
}
